import { get } from 'vuex-pathify';

export default {
  data: () => ({
    isDownloadAttributesDialogLoaded: false,
    isDownloadAttributesDialogVisible: false,
    isResetColumnStateDialogLoaded: false,
    isResetColumnStateDialogVisible: false,
  }),
  computed: {
    isDataExportModuleEnabled: get('admin/additionalModules@DATA_EXPORT.enabled'),
    modulesPermissions: get('users/toolsPermissions'),
    hasDataExportPermissions() {
      return this.modulesPermissions['DATA_EXPORT']
        ? this.isDataExportModuleEnabled && this.modulesPermissions['DATA_EXPORT'].main_value > 0
        : true;
    },
    tableMenuItems() {
      return [
        ...(this.hasDataExportPermissions
          ? [
              {
                name: 'downloadData',
              },
            ]
          : []),
        {
          name: 'resetColumnState',
        },
      ];
    },
  },
  methods: {
    openDownloadAttributesDialog() {
      this.isDownloadAttributesDialogLoaded = true;
      this.isDownloadAttributesDialogVisible = true;
    },
    resetColumnStateHandler() {
      this.isResetColumnStateDialogLoaded = true;
      this.isResetColumnStateDialogVisible = true;
    },
    resetColumnState() {
      const currentState = JSON.parse(localStorage.getItem('columnsState')) || {};
      const stateCopy = { ...currentState };
      delete stateCopy[this.layerId];
      localStorage.setItem('columnsState', JSON.stringify(stateCopy));
      this.gridOptions.api.setColumnDefs([]);
      setTimeout(() => {
        const columnsDefs = this.getColumnDefs(
          undefined,
          this.currentLayer.form_schema.elements,
          this.attributesMetadata
        );
        this.gridOptions.api.setColumnDefs(columnsDefs);
      }, 0);
      this.isResetColumnStateDialogVisible = false;
    },
  },
};
